import React, { useState } from "react";
import { Box, Typography, TextField, InputAdornment, MenuItem, Select, FormControl, IconButton, Radio, RadioGroup, FormControlLabel, Button, Avatar, Pagination, useMediaQuery, useTheme } from "@mui/material";
import Drawer from "components/mui/Drawer";
import SearchIcon from "@mui/icons-material/Search";
import AppCardComponent from "../../components/mui/AppCardComponent";
import AppBoxComponent from "../../components/mui/AppBoxComponent";
import { useGetFinfactorBankTransactionsQuery } from "../../store/api/finfactorBank.apislice";
import DateRangePicker from "../../components/common/DateRangePicker";
import CommonConsentTable from "../../components/FinFactorInvestment/CommonConsentTable";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import circleicon from "../../assets/circleicon.svg";
import analysis1 from "../../assets/Spreadinganalysis1.png";
import analysis2 from "../../assets/Spendinganalysis2.png";
import ComingSoonCard from "../../components/common/ComingSoonCard";
import FinBankDetailedComponent from "../../components/FinFactorInvestment/FinBankDetailedComponet";
import FinFactorBankCard from "../../components/common/cards/FinFactorBankCard";
import CloseIcon from "@mui/icons-material/Close";
import { getLogoUrl, getFundInitial } from "../../utils/getLogoUrl";

import NodisplayComponent from "../../components/common/NodisplayComponent";

const FinBankComponentContainer = ({ bank, onBack }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [filterValue, setFilterValue] = useState("all");
    const [amountRange, setAmountRange] = useState({ from: "", to: "" });
    const [tempFilterValue, setTempFilterValue] = useState("all");
    const [tempAmountRange, setTempAmountRange] = useState({ from: "", to: "" });

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // API Query
    const {
        data: transactionData = { transactions: [], pagination: {} },
        isLoading,
        isError
    } = useGetFinfactorBankTransactionsQuery({
        id: bank?.id,
        type: filterValue,
        page: currentPage,
        limit: pageSize,
        minAmount: amountRange.from,
        maxAmount: amountRange.to
    }, { skip: !bank?.id });

    const transactions = transactionData.transactions || [];
    const pagination = transactionData.pagination || {};

    return (
        <>
            {/* Top Bank Card */}
            <Box sx={{ p: { xs: 1.5, md: 2 } }}>
                <FinFactorBankCard
                    logo={getLogoUrl(bank)}
                    fallbackIcon={getFundInitial(bank)}
                    bankName={bank?.bankName}
                    accountNumber={bank?.accountNumber}
                    nomineeStatus={bank?.NomineStatus}
                    balance={bank?.balance}
                    accountType={bank?.accountType}
                    showChevron={false}
                    sx={{
                        mb: 3,
                        backgroundColor: "#1C2032",
                        border: "1px solid rgba(255, 255, 255, 0.1)"
                    }}
                />
            </Box>
            <AppCardComponent
                onBack={onBack}
                sx={{
                    p: { xs: 1.5, md: 2 },
                    backgroundColor: "#1C2032",
                    borderRadius: "12px",
                    color: "white"
                }}
            >
                {/* Transactions Section */}
                <AppBoxComponent
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'flex-start', md: 'center' },
                        mb: 3,
                        gap: { xs: 2, md: 0 }
                    }}>
                        <Typography variant="h5" fontWeight="600" color="white" sx={{ fontSize: { xs: "20px", md: "24px" } }}>
                            Transactions
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 1.5,
                            alignItems: { xs: 'stretch', sm: 'center' },
                            width: { xs: '100%', md: 'auto' }
                        }}>


                            <Button
                                onClick={() => {
                                    setTempFilterValue(filterValue);
                                    setTempAmountRange(amountRange);
                                    setIsDrawerOpen(true);
                                }}
                                sx={{
                                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                                    color: "white",
                                    borderRadius: "10px",
                                    height: "45px",
                                    width: { xs: "100%", sm: "auto" },
                                    minWidth: "200px",
                                    border: "1px solid rgba(255, 255, 255, 0.1)",
                                    textTransform: "none",
                                    fontSize: { xs: "12px", sm: "14px" },
                                    fontWeight: 400,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 2,
                                    "&:hover": {
                                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    }
                                }}
                            >
                                {filterValue === "all" ? "Filter by" : filterValue.charAt(0).toUpperCase() + filterValue.slice(1)}
                                <KeyboardArrowDownIcon sx={{ fontSize: "16px", color: "rgba(255,255,255,0.7)" }} />
                            </Button>

                            {/* Date Picker */}
                            <DateRangePicker
                                label="Select Date Range"
                                startIcon={<CalendarMonthIcon sx={{ color: "rgba(255,255,255,0.5)", fontSize: "18px" }} />}
                                selectSx={{
                                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                                    borderRadius: "10px",
                                    height: "45px",
                                    border: "1px solid rgba(255, 255, 255, 0.1)",
                                    color: "white",
                                    fontSize: "14px",
                                    minWidth: "200px",
                                    width: { xs: "100%", sm: "auto" },
                                    py: 0
                                }}
                            />
                        </Box>
                    </Box>

                    {/* Transaction List using CommonConsentTable */}
                    <Box sx={{ mt: 2 }}>
                        {isError || transactions.length === 0 ? (
                            <NodisplayComponent
                                title={isError ? "Error Loading Transactions" : "No Transactions Found"}
                                subtitle={isError ? "We couldn't retrieve your transactions at this time. Please try again later." : "No transactions available for this account."}
                            />
                        ) : (() => {
                            const totalRows = pagination.total || transactions.length;
                            const paginatedTransactions = transactions; // API already paginates

                            return (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    {paginatedTransactions.map((tx) => (
                                        <Box
                                            key={tx.id}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: { xs: 'flex-start', md: 'center' },
                                                justifyContent: 'space-between',
                                                p: 2,
                                                backgroundColor: "rgba(255, 255, 255, 0.02)",
                                                borderRadius: "12px",
                                                border: "1px solid rgba(255, 255, 255, 0.05)",
                                                transition: "all 0.2s ease-in-out",
                                                gap: { xs: 1.5, md: 2 },
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                                                    borderColor: "rgba(255, 255, 255, 0.1)",
                                                }
                                            }}
                                        >
                                            {/* Mobile Layout (Columnar) */}
                                            <Box sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: 'column', width: '100%', gap: 1 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
                                                    <Typography
                                                        variant="body1"
                                                        fontWeight="500"
                                                        color="rgba(255, 255, 255, 0.9)"
                                                        sx={{
                                                            fontSize: "14px",
                                                            wordBreak: "break-word",
                                                            flex: 1,
                                                            lineHeight: 1.4
                                                        }}
                                                    >
                                                        {tx.merchantName}
                                                    </Typography>
                                                    <Typography
                                                        variant="h6"
                                                        fontWeight="600"
                                                        sx={{
                                                            fontSize: "16px",
                                                            color: tx.isCredit ? "#22c55e" : "#ef4444",
                                                            flexShrink: 0,
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {tx.amount?.replace("+", "").trim()}
                                                    </Typography>
                                                </Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "rgba(255, 255, 255, 0.4)",
                                                        fontSize: "11px",
                                                    }}
                                                >
                                                    {tx.timestamp}
                                                </Typography>
                                            </Box>

                                            {/* Column 1: Timestamp (Desktop Only) */}
                                            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2, flexShrink: 0, minWidth: "180px" }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "rgba(255, 255, 255, 0.5)",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {tx.timestamp}
                                                </Typography>
                                            </Box>

                                            {/* Column 2: Merchant Name (Center - Desktop Only) */}
                                            <Box sx={{ flex: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-start', minWidth: 0, px: 2 }}>
                                                <Typography
                                                    variant="body1"
                                                    fontWeight="500"
                                                    color="rgba(255, 255, 255, 0.8)"
                                                    sx={{
                                                        fontSize: "16px",
                                                        textAlign: "left",
                                                        wordBreak: "break-word"
                                                    }}
                                                >
                                                    {tx.merchantName}
                                                </Typography>
                                            </Box>

                                            {/* Column 3: Amount (End - Desktop Only) */}
                                            <Box sx={{ flexShrink: 0, minWidth: "120px", display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="600"
                                                    sx={{
                                                        fontSize: "18px",
                                                        color: tx.isCredit ? "#22c55e" : "#ef4444"
                                                    }}
                                                >
                                                    {tx.amount?.replace("+", "").trim()}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    ))}

                                    {/* Pagination Footer */}
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', md: 'row' },
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mt: 4,
                                        mb: 2,
                                        gap: 2,
                                        px: 1
                                    }}>
                                        <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "14px" }}>
                                            {(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, totalRows)} of {totalRows} rows
                                        </Typography>

                                        <Pagination
                                            count={Math.ceil(totalRows / pageSize)}
                                            page={currentPage}
                                            onChange={(e, page) => setCurrentPage(page)}
                                            showFirstButton={!isMobile}
                                            showLastButton={!isMobile}
                                            siblingCount={isMobile ? 0 : 1}
                                            boundaryCount={isMobile ? 1 : 1}
                                            size={isMobile ? "small" : "medium"}
                                            shape="rounded"
                                            sx={{
                                                "& .MuiPaginationItem-root": {
                                                    color: "rgba(255, 255, 255, 0.6)",
                                                    backgroundColor: "transparent",
                                                    border: "1px solid rgba(255, 255, 255, 0.2)",
                                                    borderRadius: "6px",
                                                    minWidth: { xs: "32px", md: "36px" },
                                                    height: { xs: "32px", md: "36px" },
                                                    "&:hover": {
                                                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                                                    },
                                                    "&.Mui-selected": {
                                                        backgroundColor: "#55B4E3", // Updated blue to match Figma
                                                        color: "white",
                                                        border: "none",
                                                        "&:hover": {
                                                            backgroundColor: "#55B4E3",
                                                        }
                                                    },
                                                    "& .MuiPaginationItem-icon": {
                                                        fontSize: { xs: "18px", md: "20px" },
                                                        color: "rgba(255, 255, 255, 0.6)"
                                                    }
                                                }
                                            }}
                                        />

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Select
                                                value={pageSize}
                                                onChange={(e) => {
                                                    setPageSize(e.target.value);
                                                    setCurrentPage(1);
                                                }}
                                                size="small"
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: "#13172a",
                                                            color: "white",
                                                            border: "1px solid rgba(255, 255, 255, 0.1)",
                                                            mt: 0.5,
                                                            "& .MuiMenuItem-root": {
                                                                fontSize: "13px",
                                                                "&:hover": {
                                                                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                                                                },
                                                                "&.Mui-selected": {
                                                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                                                    color: "#55B4E3",
                                                                }
                                                            }
                                                        }
                                                    }
                                                }}
                                                sx={{
                                                    color: "rgba(255, 255, 255, 0.7)",
                                                    fontSize: "13px",
                                                    backgroundColor: "transparent",
                                                    borderRadius: "8px",
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "rgba(255, 255, 255, 0.3)",
                                                    },
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "rgba(255, 255, 255, 0.5)",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#55B4E3",
                                                        borderWidth: "1.5px"
                                                    },
                                                    "& .MuiSvgIcon-root": {
                                                        color: "rgba(255, 255, 255, 0.5)"
                                                    }
                                                }}
                                            >
                                                <MenuItem value={10}>10 per page</MenuItem>
                                                <MenuItem value={20}>20 per page</MenuItem>
                                                <MenuItem value={50}>50 per page</MenuItem>
                                            </Select>
                                        </Box>
                                    </Box>
                                </Box>
                            );
                        })()}
                    </Box>
                </AppBoxComponent>
            </AppCardComponent>

            {/* Spending Analysis Section */}
            <AppCardComponent
                sx={{
                    p: { xs: 2, md: 2 },
                    backgroundColor: "#13172a",
                    borderRadius: "12px",
                    color: "white",
                    mt: 3,
                    border: "1px solid rgba(255, 255, 255, 0.1)"
                }}
            >
                {/* Header Section */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: { xs: 2.5, md: 0 },
                    mb: { xs: 2, md: 0 }
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box
                            component="img"
                            src={circleicon}
                            alt="spending analysis"
                            sx={{ width: 30, height: 30 }}
                        />
                        <Typography variant="h5" fontWeight="600" color="white" sx={{ fontSize: { xs: "20px", md: "24px" } }}>
                            Spending analysis
                        </Typography>
                    </Box>

                    {/* Summary Metric Cards */}
                    <Box
                        component="img"
                        src={analysis1}
                        alt="spending analysis totals"
                        sx={{
                            height: { xs: "auto", md: 60 },
                            width: { xs: "100%", md: "auto" },
                            objectFit: 'contain'
                        }}
                    />
                </Box>

                {/* Detailed Charts Section */}
                <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Box
                        component="img"
                        src={analysis2}
                        alt="spending analysis charts"
                        sx={{
                            width: '100%',
                            borderRadius: '8px',
                            filter: 'grayscale(20%) opacity(0.8)' // Indicated that it's inactive
                        }}
                    />

                    {/* Coming Soon Overlay */}
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 2
                    }}>
                        <ComingSoonCard />
                    </Box>
                </Box>
            </AppCardComponent>

            {/* Filter Drawer */}
            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                sx={{ zIndex: 9999 }}
                PaperProps={{
                    sx: {
                        width: { xs: "100%", sm: 400 },
                        backgroundColor: "#13172a", // Dark blue shade from Figma
                        color: "white",
                        p: 0,
                    }
                }}
            >
                {/* Drawer Header */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: 3,
                    py: 2,
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                    <Typography variant="h6" fontWeight="600">Filter</Typography>
                    <IconButton onClick={() => setIsDrawerOpen(false)} sx={{ color: "white" }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ p: 3, flexGrow: 1 }}>
                    {/* Transaction Type */}
                    <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.6)", mb: 2 }}>
                        Transaction Type
                    </Typography>
                    <RadioGroup
                        row
                        value={tempFilterValue}
                        onChange={(e) => setTempFilterValue(e.target.value)}
                        sx={{ mb: 4 }}
                    >
                        <FormControlLabel
                            value="all"
                            control={<Radio size="small" sx={{ color: "rgba(255,255,255,0.3)", '&.Mui-checked': { color: "#0EA5E9" } }} />}
                            label={<Typography variant="body2">All</Typography>}
                        />
                        <FormControlLabel
                            value="credit"
                            control={<Radio size="small" sx={{ color: "rgba(255,255,255,0.3)", '&.Mui-checked': { color: "#0EA5E9" } }} />}
                            label={<Typography variant="body2">Credit</Typography>}
                        />
                        <FormControlLabel
                            value="debit"
                            control={<Radio size="small" sx={{ color: "rgba(255,255,255,0.3)", '&.Mui-checked': { color: "#0EA5E9" } }} />}
                            label={<Typography variant="body2">Debit</Typography>}
                        />
                    </RadioGroup>

                    {/* Amount Range */}
                    <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.6)", mb: 2 }}>
                        Amount Range
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TextField
                            placeholder="From"
                            value={tempAmountRange.from}
                            onChange={(e) => {
                                const val = e.target.value.replace(/[^0-9]/g, "");
                                setTempAmountRange(prev => ({ ...prev, from: val }));
                            }}
                            variant="outlined"
                            size="small"
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><Typography sx={{ color: 'white', fontSize: '14px' }}>₹</Typography></InputAdornment>,
                            }}
                            sx={{
                                backgroundColor: "rgba(255, 255, 255, 0.02)",
                                borderRadius: "8px",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                "& .MuiInputBase-input": { color: "white", fontSize: '14px' }
                            }}
                        />
                        <Typography sx={{ color: "rgba(255, 255, 255, 0.5)" }}>-</Typography>
                        <TextField
                            placeholder="To"
                            value={tempAmountRange.to}
                            onChange={(e) => {
                                const val = e.target.value.replace(/[^0-9]/g, "");
                                setTempAmountRange(prev => ({ ...prev, to: val }));
                            }}
                            variant="outlined"
                            size="small"
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><Typography sx={{ color: 'white', fontSize: '14px' }}>₹</Typography></InputAdornment>,
                            }}
                            sx={{
                                backgroundColor: "rgba(255, 255, 255, 0.02)",
                                borderRadius: "8px",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                "& .MuiInputBase-input": { color: "white", fontSize: '14px' }
                            }}
                        />
                    </Box>

                    {/* Extra padding to prevent overlap with footer and help button */}
                    <Box sx={{ height: "150px" }} />
                </Box>

                {/* Drawer Footer - Fixed/Sticky at bottom */}
                <Box sx={{
                    px: 3,
                    py: 2.5,
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: "#13172a",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2500 // Higher than Help button if possible
                }}>
                    <Button
                        onClick={() => {
                            setTempFilterValue("all");
                            setTempAmountRange({ from: "", to: "" });
                        }}
                        sx={{
                            backgroundColor: "#475569", // Grey color from Figma
                            color: "white",
                            textTransform: "none",
                            borderRadius: "8px",
                            px: 3,
                            height: "45px",
                            fontSize: "16px",
                            fontWeight: 600,
                            "&:hover": {
                                backgroundColor: "#334155",
                            }
                        }}
                    >
                        Clear all
                    </Button>
                    <Button
                        onClick={() => {
                            setFilterValue(tempFilterValue);
                            setAmountRange(tempAmountRange);
                            setIsDrawerOpen(false);
                        }}
                        sx={{
                            backgroundColor: "#38bdf8", // Bright blue color from Figma
                            color: "white",
                            textTransform: "none",
                            borderRadius: "8px",
                            px: 3,
                            height: "45px",
                            fontSize: "16px",
                            fontWeight: 600,
                            "&:hover": {
                                backgroundColor: "#0ea5e9",
                            }
                        }}
                    >
                        Apply Filter
                    </Button>
                </Box>
            </Drawer>
        </>
    );
};

export default FinBankComponentContainer;
